export default __webpack_public_path__ + "static/media/IN.d1d319fb.svg";